/* eslint-disable @typescript-eslint/no-explicit-any */
import { isAxiosError } from 'axios';
import hwaxios from '../api-service/HWAxios';
import { usbCertificatesType } from '../reduxExports';
const url = process.env.REACT_APP_SERVER_BASE_URL


export const fetchUsbCertificatesData: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<UsbCertificatesAction>) => void): Promise<void> => {
    try {
      const loaderStartAction: Partial<UsbCertificatesAction> = {
        type: usbCertificatesType.SET_LOADER,
        loader: true
      }
      dispatch(loaderStartAction);
      const response = await hwaxios.post(url + '/usbCertificate/list', reqBody)
      const action: Partial<UsbCertificatesAction> = {
        type: usbCertificatesType.FETCH_USB_CERTIFICATES_DATA,
        usbCertificates: response.data?.data?.usbCertificates,
        usbCertificatesCount: response.data?.data?.usbCertificatesCount,
      }
      dispatch(action)
      if (response?.status === 200) {
        const loaderEndAction: Partial<UsbCertificatesAction> = {
          type: usbCertificatesType.SET_LOADER,
          loader: false
        }
        dispatch(loaderEndAction);
      }
    } catch (error) {
      const loaderEndAction: Partial<UsbCertificatesAction> = {
        type: usbCertificatesType.SET_LOADER,
        loader: false
      }
      dispatch(loaderEndAction);
      console.error(error)
      throw error
    }
  }

export const generateUsbCertificates: any = (reqBody: unknown) => async () => {
    try {
      const { data, status } = await hwaxios.post(url + '/usbCertificate', reqBody)
      return { data, status };
    } catch (error) {
      if (isAxiosError(error)) {
        if (error.response) {
          const data = error.response.data;
          const status = error.response.status;
          return { data, status };
        }
      } else {
        return {
          data: 'Something went wrong', status: 400
        }
      }
    }
  }


export const setUsbCertificatesListTableProps: any = (data) => async (dispatch: (arg0: Partial<UsbCertificatesAction>) => void): Promise<void> => {
  const action: Partial<UsbCertificatesAction> = {
    type: usbCertificatesType.SET_USB_CERTIFICATES_LIST_TABLE_PROPS,
    usbCertificatesListTableProps: data,
  };
  dispatch(action);
}



export const fetchChargerCertificatesInfoData: any = (reqBody: unknown) => async (dispatch: (arg0: Partial<UsbCertificatesAction>) => void): Promise<void> => {
  try {
    const loaderStartAction: Partial<UsbCertificatesAction> = {
      type: usbCertificatesType.SET_LOADER,
      loader: true
    }
    dispatch(loaderStartAction);
    const response = await hwaxios.post(url + '/charger-certificate-info/list', reqBody)
    const action: Partial<UsbCertificatesAction> = {
      type: usbCertificatesType.FETCH_CHARGER_CERTIFICATES_INFO_DATA,
      chargerCertificatesInfo: response.data?.data?.chargerCertificatesInfo,
      chargerCertificatesInfoCount: response.data?.data?.count,
    }
    dispatch(action)
    if (response?.status === 200) {
      const loaderEndAction: Partial<UsbCertificatesAction> = {
        type: usbCertificatesType.SET_LOADER,
        loader: false
      }
      dispatch(loaderEndAction);
    }
  } catch (error) {
    const loaderEndAction: Partial<UsbCertificatesAction> = {
      type: usbCertificatesType.SET_LOADER,
      loader: false
    }
    dispatch(loaderEndAction);
    console.error(error)
    throw error
  }
}

export const setChargerCertificatesInfoListTableProps: any = (data) => async (dispatch: (arg0: Partial<UsbCertificatesAction>) => void): Promise<void> => {
  const action: Partial<UsbCertificatesAction> = {
    type: usbCertificatesType.SET_CHARGER_CERTIFICATES_INFO_LIST_TABLE_PROPS,
    chargerCertificatesInfoListTableProps: data,
  };
  dispatch(action);
}

export const pushChargerCertificate: any = (reqBody: { certId: string }) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/charger-certificate-info/push-certificate', reqBody)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      const data = error.response.data;
      const status = error.response.status;
      return { data, status };
    }
    return {
      data: { message: 'Something went wrong' }, status: 400
    }
  }
}

export const generateChargerCertificates: any = (reqBody: unknown) => async () => {
  try {
    const { data, status } = await hwaxios.post(url + '/charger-certificate-info', reqBody)
    return { data, status };
  } catch (error) {
    if (isAxiosError(error)) {
      if (error.response) {
        const data = error.response.data;
        const status = error.response.status;
        return { data, status };
      }
    } else {
      return {
        data: { messsage: 'Something went wrong' }, status: 400
      }
    }
  }
}
